import { Observable } from 'rxjs'
import { Injectable, Injector } from '@angular/core'
import { Action } from '@ngrx/store'
import { App, NavController, ModalController, ModalOptions } from 'ionic-angular'
import { ViewModel } from '../view-model'
import { UIEvent, UIEventHub } from './event.service'
import { ApiCall, RestClient } from './rest-client.service'
import { ToastComponent, ConfirmDialogPage } from '@ar2/common'
import * as moment from 'moment'
import * as download from 'downloadjs'
import * as ENV from '../environment'
import { AuthorizationService, TicketManager, LoadingService } from '@ar2/common'
import { SystemMessageService } from './system-message.service'

/**
 * アクションオブジェクト
 * @author nabla2.metamodel.generator
 */
export class UIAction implements Action {
  type : string
  desc : string
  event: UIEvent<any>
  [extraProps: string]: any
  static CALL_API = 'core/CALL_API'
  static RE_SEARCH_TABLE = 'core/RE_SEARCH_TABLE'
  static APPLY_API_RESULT = 'core/APPLY_API_RESULT'
  static MERGE_API_RESULT = 'core/MERGE_API_RESULT'
  static SHOW_API_RESPONSE = 'core/SHOW_API_RESPONSE'
  static SHOW_API_USER_ERROR = 'core/SHOW_API_USER_ERROR'
  static RESET_USER_ERROR = 'core/RESET_USER_ERROR'
  static SHOW_API_USER_WARNING = 'core/SHOW_API_USER_WARNING'
  static SAVE_RESPONSE_AS_FILE = 'core/SAVE_RESPONSE_AS_FILE'
  static SAVE_GLOBAL_OFFICIAL_RESPONSE_AS_FILE = 'core/SAVE_GLOBAL_OFFICIAL_RESPONSE_AS_FILE'
  static SAVE_LOCAL_OFFICIAL_RESPONSE_AS_FILE = 'core/SAVE_LOCAL_OFFICIAL_RESPONSE_AS_FILE'
  static SAVE_WEEKLY_SALES_INVENTORY_RESPONSE_AS_FILE = 'core/SAVE_WEEKLY_SALES_INVENTORY_RESPONSE_AS_FILE'
  static SAVE_SKU_SALES_INVENTORY_RESPONSE_AS_FILE = 'core/SAVE_SKU_SALES_INVENTORY_RESPONSE_AS_FILE'
  static SAVE_RESPONSE_AS_JSON = 'core/SAVE_RESPONSE_AS_JSON'
  static SAVE_REST_API_RESPONSE_AS_JSON = 'core/SAVE_REST_API_RESPONSE_AS_JSON'
  static MOVE_TO_PAGE = 'core/MOVE_TO_PAGE'
  static BACK_TO_PREV_PAGE = 'core/BACK_TO_PREV_PAGE'
  static REDIRECT_TO_PAGE = 'core/REDIRECT_TO_PAGE'
  static MOVE_TO_MODAL_PAGE = 'core/MOVE_TO_MODAL_PAGE'
  static CLOSE_MODAL_PAGE = 'core/CLOSE_MODAL_PAGE'
  static SHOW_CONFIRM_DIALOG = 'core/SHOW_CONFIRM_DIALOG'
  static OPEN_NEW_WINDOW = 'core/OPEN_NEW_WINDOW'
  static SHOW_WARNING_DIALOG = 'core/SHOW_WARNING_DIALOG'
  static REACQUIRE_AUTH_INFO = 'core/REACQUIRE_AUTH_INFO'
  static REACQUIRE_AIM_AUTH_INFO = 'core/REACQUIRE_AIM_AUTH_INFO'
  static SHOW_CONFIRM_DIALOG_MESSAGE = 'core/SHOW_CONFIRM_DIALOG_MESSAGE'
  static SHOW_CONFIRM_DIALOG_MESSAGE_WITH_PARAM = 'core/SHOW_CONFIRM_DIALOG_MESSAGE_WITH_PARAM'
  static SCROLL_TO_TOP = 'core/SCROLL_TO_TOP'
  static OPEN_MENU = 'core/OPEN_MENU'
  static UPDATE_VIEW_MODEL = 'core/UPDATE_VIEW_MODEL'
  static UPDATE_VIEW_MODEL_WITH_URL_PARAMETER = 'core/UPDATE_VIEW_MODEL_WITH_URL_PARAMETER'
  static UPDATE_VIEW_MODEL_WITH_USER_ID = 'core/UPDATE_VIEW_MODEL_WITH_USER_ID'
  static UPDATE_VIEW_MODEL_WITH_BU_CD = 'core/UPDATE_VIEW_MODEL_WITH_BU_CD'
  static UPDATE_VIEW_MODEL_WITH_BU_NAME = 'core/UPDATE_VIEW_MODEL_WITH_BU_NAME'
  static UPDATE_VIEW_MODEL_WITH_DATE_NOW = 'core/UPDATE_VIEW_MODEL_WITH_DATE_NOW'
  static UPDATE_VIEW_MODEL_WITH_DATE_ADD_MONTHS = 'core/UPDATE_VIEW_MODEL_WITH_DATE_ADD_MONTHS'
  static MERGE_VIEW_MODEL = 'core/MERGE_VIEW_MODEL'
  static PUSH_VIEW_MODEL = 'core/PUSH_VIEW_MODEL'
  static DELETE_VIEW_MODEL_WITH_ROW_INDEX = 'core/DELETE_VIEW_MODEL_WITH_ROW_INDEX'
  static UPDATE_VIEW_MODEL_WITH_KEYS_MAPPING = 'core/UPDATE_VIEW_MODEL_WITH_KEYS_MAPPING'
  static UPDATE_VIEW_MODEL_WITH_SELECTED_KEY_VALUE = 'core/UPDATE_VIEW_MODEL_WITH_SELECTED_KEY_VALUE'
  static UPDATE_VIEW_MODEL_WITH_INDEXED_VALUE = 'core/UPDATE_VIEW_MODEL_WITH_INDEXED_VALUE'
  static UPDATE_VIEW_MODEL_WITH_ALL_VALUES = 'core/UPDATE_VIEW_MODEL_WITH_ALL_VALUES'
  static UPDATE_VIEW_MODEL_WITH_ALL_ROWS = 'core/UPDATE_VIEW_MODEL_WITH_ALL_ROWS'
  static UPDATE_VIEW_MODEL_WITH_ACTIVE_ROWS = 'core/UPDATE_VIEW_MODEL_WITH_ACTIVE_ROWS'
  static UPDATE_VIEW_MODEL_WITH_INDEXED_NUMBER = 'core/UPDATE_VIEW_MODEL_WITH_INDEXED_NUMBER'
  static UPDATE_VIEW_MODEL_WITH_INDEX_NUMBER = 'core/UPDATE_VIEW_MODEL_WITH_INDEX_NUMBER'
  static UPDATE_VIEW_MODEL_WITH_CONTENT = 'core/UPDATE_VIEW_MODEL_WITH_CONTENT'
  static UPDATE_INDEXED_VALUE_WITH_VIEW_MODEL = 'core/UPDATE_INDEXED_VALUE_WITH_VIEW_MODEL'
  static UPDATE_COLUMN_VISIBLE_VALUE = 'core/UPDATE_COLUMN_VISIBLE_VALUE'
  static UPDATE_COLUMNS_VISIBLE_VALUE = 'core/UPDATE_COLUMNS_VISIBLE_VALUE'
  static UPDATE_RANGE_COLUMNS_VISIBLE_VALUE = 'core/UPDATE_RANGE_COLUMNS_VISIBLE_VALUE'
  static RESET_VIEW_MODEL = 'core/RESET_VIEW_MODEL'
  static TAKE_SNAPSHOT_OF_VIEW_MODEL = 'core/TAKE_SNAPSHOT_OF_VIEW_MODEL'
  static TAKE_SNAPSHOT_OF_VIEW_MODEL_ON_SESSION_STORAGE = 'core/TAKE_SNAPSHOT_OF_VIEW_MODEL_ON_SESSION_STORAGE'
  static TAKE_SNAPSHOT_OF_VIEW_MODEL_ON_HEAP = 'core/TAKE_SNAPSHOT_OF_VIEW_MODEL_ON_HEAP'
  static RESET_VIEW_MODEL_TO_LATEST_SNAPSHOT = 'core/RESET_VIEW_MODEL_TO_LATEST_SNAPSHOT'
  static RESET_VIEW_MODEL_TO_LATEST_SNAPSHOT_ON_SESSION_STORAGE = 'core/RESET_VIEW_MODEL_TO_LATEST_SNAPSHOT_ON_SESSION_STORAGE'
  static SHOW_TOAST = 'core/SHOW_TOAST'
  static UPDATE_VIEW_MODEL_WITH_SELECTED_LABEL_VALUE = 'core/UPDATE_VIEW_MODEL_WITH_SELECTED_LABEL_VALUE'
  static UPDATE_VIEW_MODEL_WITH_SELECTED_LABEL_VALUES = 'core/UPDATE_VIEW_MODEL_WITH_SELECTED_LABEL_VALUES'
  static SPLIT_VALUE_AND_UPDATE_VIEW_MODEL = 'core/SPLIT_VALUE_AND_UPDATE_VIEW_MODEL'
  static UPDATE_LY_BASED_ON_TY = 'core/UPDATE_LY_BASED_ON_TY'
  static UPDATE_VIEW_MODEL_WITH_PULLDOWN_VALUE = 'core/UPDATE_VIEW_MODEL_WITH_PULLDOWN_VALUE'
  static SHOW_TOAST_MESSAGE = 'core/SHOW_TOAST_MESSAGE'
  static SHOW_TOAST_MESSAGE_WITH_PARAM = 'core/SHOW_TOAST_MESSAGE_WITH_PARAM'
  static SHOW_ERROR_MESSAGE_WITH_VIEW_MODEL = 'core/SHOW_ERROR_MESSAGE_WITH_VIEW_MODEL'
  static PUSH_VALUES_TO_VIEW_MODEL = 'core/PUSH_VALUES_TO_VIEW_MODEL'
  static MOVE_VALUES_TO_VIEW_MODEL = 'core/MOVE_VALUES_TO_VIEW_MODEL'
  static UPDATE_SPREADSHEET_CELL_VALUE = 'core/UPDATE_SPREADSHEET_CELL_VALUE'
  static UPDATE_SPREADSHEET_COLUMN_VALUE = 'core/UPDATE_SPREADSHEET_COLUMN_VALUE'
  static UPDATE_BY_START_WEEK_DATE = 'core/UPDATE_BY_START_WEEK_DATE'
  static SET_AUTH_AIM_USER_INFO = 'core/SET_AUTH_AIM_USER_INFO'
}

/**
 * アクションクリエータ定義
 */
@Injectable()
export class ActionCreator {

  /**
   * コンストラクタ
   */
  constructor(
    public eventHub:UIEventHub,
    public restClient:RestClient,
    public app:App,
    public modalCtrl:ModalController,
    public toastComponent: ToastComponent,
    public authService: AuthorizationService,
    public systemMessageService: SystemMessageService,
    public loadingService: LoadingService,
    private ticketMgr: TicketManager,
  ) {}

  /**
   * 画面遷移コントローラ
   */
  get nav():NavController {
    return this.app.getRootNavs()[0]
  }

  /**
   * モーダル画面コントローラ
   */
  get modal():ModalController {
    return this.modalCtrl
  }

  /**
   * Viewコントローラ
   */
  get closeModal() {
    return this.app.navPop()
  }

  /**
   * Toastコントローラ
   */
  get toast():ToastComponent {
    return this.toastComponent
  }

  /**
   * 認可サービス
   */
  get auth():AuthorizationService {
    return this.authService
  }

  /**
   * システムメッセージ取得サービス
   */
  get systemMessage():SystemMessageService {
    return this.systemMessageService
  }

  /**
   * ローディングサービス
   */
  get loading(): LoadingService {
    return this.loadingService
  }

  /**
   * 選択したGbuCD
   */
  get selectedGbuCD():string {
    return this.ticketMgr.get() ? this.authService.getSelectedGbuCD() || '' : ''
  }

  /**
   * API呼び出し定義に従ってAPIを実行する
   * @param apiCall API呼び出し
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  callApi = (
    apiCall:ApiCall, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.CALL_API,
      apiCall: apiCall,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * 表示モデルの該当項目の値を更新して前回の検索APIを実行する
   * @param path 画面モデル項目
   * @param value 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  reSearchTable = (
    path:string, value:(m:ViewModel) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.RE_SEARCH_TABLE,
      path: path,
      value: value,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * 指定されたAPIの実行結果を画面に反映する
   * @param apiCall API呼び出し
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  applyApiResult = (
    apiCall:ApiCall, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.APPLY_API_RESULT,
      apiCall: apiCall,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * 指定されたAPIの実行結果を既存の表示モデルにマージする
   * @param apiCall API呼び出し
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  mergeApiResult = (
    apiCall:ApiCall, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.MERGE_API_RESULT,
      apiCall: apiCall,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * APIの実行結果を画面に反映する
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  showApiResponse = (
    event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.SHOW_API_RESPONSE,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * APIのユーザエラーの内容を画面に反映する
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  showApiUserError = (
    event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.SHOW_API_USER_ERROR,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * 画面上のユーザエラーを全てクリアする
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  resetUserError = (
    event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.RESET_USER_ERROR,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * APIのユーザワーニングの内容を画面に反映する
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  showApiUserWarning = (
    event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.SHOW_API_USER_WARNING,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * レスポンスボディの内容をローカルファイルに保存する
   * @param filename 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  saveResponseAsFile = (
    filename:(m:ViewModel) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.SAVE_RESPONSE_AS_FILE,
      filename: filename,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * グローバルオフィシャルのレスポンスボディの内容をローカルファイルに保存する
   * @param yrSsnName 値
   * @param gDept 値
   * @param filename 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  saveGlobalOfficialResponseAsFile = (
    yrSsnName:(m:ViewModel) => any, gDept:(m:ViewModel) => any, filename:(m:ViewModel) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.SAVE_GLOBAL_OFFICIAL_RESPONSE_AS_FILE,
      yrSsnName: yrSsnName,
      gDept: gDept,
      filename: filename,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * ローカルオフィシャルのレスポンスボディの内容をローカルファイルに保存する
   * @param yrSsnName 値
   * @param buName 値
   * @param rgnName 値
   * @param gDept 値
   * @param filename 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  saveLocalOfficialResponseAsFile = (
    yrSsnName:(m:ViewModel) => any, buName:(m:ViewModel) => any, rgnName:(m:ViewModel) => any, gDept:(m:ViewModel) => any, filename:(m:ViewModel) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.SAVE_LOCAL_OFFICIAL_RESPONSE_AS_FILE,
      yrSsnName: yrSsnName,
      buName: buName,
      rgnName: rgnName,
      gDept: gDept,
      filename: filename,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * 週別集約販売在庫計画のレスポンスボディの内容をローカルファイルに保存する
   * @param buName 値
   * @param rgnName 値
   * @param gDept 値
   * @param filename 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  saveWeeklySalesInventoryResponseAsFile = (
    buName:(m:ViewModel) => any, rgnName:(m:ViewModel) => any, gDept:(m:ViewModel) => any, filename:(m:ViewModel) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.SAVE_WEEKLY_SALES_INVENTORY_RESPONSE_AS_FILE,
      buName: buName,
      rgnName: rgnName,
      gDept: gDept,
      filename: filename,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * SKU販売在庫計画のレスポンスボディの内容をローカルファイルに保存する
   * @param buName 値
   * @param rgnName 値
   * @param slsSumCd 値
   * @param slsSumName 値
   * @param filename 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  saveSkuSalesInventoryResponseAsFile = (
    buName:(m:ViewModel) => any, rgnName:(m:ViewModel) => any, slsSumCd:(m:ViewModel) => any, slsSumName:(m:ViewModel) => any, filename:(m:ViewModel) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.SAVE_SKU_SALES_INVENTORY_RESPONSE_AS_FILE,
      buName: buName,
      rgnName: rgnName,
      slsSumCd: slsSumCd,
      slsSumName: slsSumName,
      filename: filename,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * レスポンスボディの内容をローカルJSONファイルに保存する
   * (deprecated)
   * この処理はJSONファイルサイズが大きくなるとメモリを大量に消費するため、原則使用しないでください。「レスポンスの内容をファイル名【値:filename:(m:ViewModel) => any】として保存する」を使用してください。
   * @param filename 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  saveResponseAsJson = (
    filename:(m:ViewModel) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.SAVE_RESPONSE_AS_JSON,
      filename: filename,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * レスポンスボディの内容をローカルJSONファイルに保存する
   * (deprecated)
   * この処理はJSONファイルサイズが大きくなるとメモリを大量に消費するため、原則使用しないでください。「レスポンスの内容をファイル名【値:filename:(m:ViewModel) => any】として保存する」を使用してください。
   * @param filename 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  saveRestApiResponseAsJson = (
    filename:(m:ViewModel) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.SAVE_REST_API_RESPONSE_AS_JSON,
      filename: filename,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * 指定した画面に遷移する。
   * 遷移先の画面は(機能名).(画面名)、もしくは、(画面名) の形で指定する。
   * 後者の場合は、同一機能の画面名に遷移する。
   * パス中の埋め込み定数は対応する画面表示項目の値に置換される。
   * @param pageName 遷移先画面名
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  moveToPage = (
    pageName:(m:ViewModel) => string, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.MOVE_TO_PAGE,
      pageName: pageName,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * 今のページを取り除いて、前の画面に戻ります。
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  backToPrevPage = (
    event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.BACK_TO_PREV_PAGE,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * 指定した画面にリダイレクトする。
   * パス中の埋め込み定数は対応する画面表示項目の値に置換される。
   * @param redirectHostNamePath 画面モデル項目
   * @param redirectPage 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  redirectToPage = (
    redirectHostNamePath:string, redirectPage:(m:ViewModel) => string, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.REDIRECT_TO_PAGE,
      redirectHostNamePath: redirectHostNamePath,
      redirectPage: redirectPage,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * 指定した画面にモーダル遷移する。
   * 遷移先の画面は(機能名).(画面名)、もしくは、(画面名) の形で指定する。
   * 後者の場合は、同一機能の画面名に遷移する。
   * また、モーダルサイズを's', 'm', 'l'で指定する。
   * パス中の埋め込み定数は対応する画面表示項目の値に置換される。
   * @param pageName 遷移先画面名
   * @param size 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  moveToModalPage = (
    pageName:(m:ViewModel) => string, size:(m:ViewModel) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.MOVE_TO_MODAL_PAGE,
      pageName: pageName,
      size: size,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * モーダル画面を閉じる。
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  closeModalPage = (
    event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.CLOSE_MODAL_PAGE,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * 確認ダイアログを表示する。
   * Optionの設定値
   * title: string型。ダイアログのタイトルを設定。
   * message: string型。ダイアログに表示するメッセージを設定。
   * cancelButton: string型。CANCELボタンに表示する文言を設定。デフォルト"CANCEL"
   * okButton: string型。OKボタンに表示する文言を設定。デフォルト"OK"
   * showClose: boolean型。CLOSEボタンの表示を設定。デフォルトtrue
   * okButtonId: OKボタンが押下されたときに引き渡されるID値を設定
   * cancelButtonId: CANCELボタンが押下されたときに引き渡されるID値を設定
   * closeButtonId: Xボタンが押下されたときに引き渡されるID値を設定
   * breakLine: '\n'での改行を有効化するためのフラグ。未設定の場合、改行無効
   * @param option 値
   * @param size 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  showConfirmDialog = (
    option:(m:ViewModel) => any, size:(m:ViewModel) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.SHOW_CONFIRM_DIALOG,
      option: option,
      size: size,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * 指定したURLの新規ウィンドウを開く。
   * @param url 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  openNewWindow = (
    url:(m:ViewModel) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.OPEN_NEW_WINDOW,
      url: url,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * ワーニングダイアログを表示する
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  showWarningDialog = (
    event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.SHOW_WARNING_DIALOG,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * GbuCdを指定して認可情報を取得する
   * @param selectedGbuCdPath 画面モデル項目
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  reacquireAuthInfo = (
    selectedGbuCdPath:string, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.REACQUIRE_AUTH_INFO,
      selectedGbuCdPath: selectedGbuCdPath,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * BuCdを指定してAIM用画面項目認可情報を取得する
   * @param selectedBuCdPath 画面モデル項目
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  reacquireAimAuthInfo = (
    selectedBuCdPath:string, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.REACQUIRE_AIM_AUTH_INFO,
      selectedBuCdPath: selectedBuCdPath,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * メッセージIDを指定して確認ダイアログを表示する。
   * Optionの設定値
   * title: string型。ダイアログのタイトルを設定。
   * messageId: string型。ダイアログに表示するメッセージのIDを設定。
   * cancelButton: string型。CANCELボタンに表示する文言を設定。デフォルト"CANCEL"
   * okButton: string型。OKボタンに表示する文言を設定。デフォルト"OK"
   * showClose: boolean型。CLOSEボタンの表示を設定。デフォルトtrue
   * okButtonId: OKボタンが押下されたときに引き渡されるID値を設定
   * cancelButtonId: CANCELボタンが押下されたときに引き渡されるID値を設定
   * closeButtonId: Xボタンが押下されたときに引き渡されるID値を設定
   * breakLine: '\n'での改行を有効化するためのフラグ。未設定の場合、改行無効
   * @param option 値
   * @param size 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  showConfirmDialogMessage = (
    option:(m:ViewModel) => any, size:(m:ViewModel) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.SHOW_CONFIRM_DIALOG_MESSAGE,
      option: option,
      size: size,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * メッセージIDとパラメーターを指定して確認ダイアログを表示する。
   * Optionの設定値
   * title: string型。ダイアログのタイトルを設定。
   * messageId: string型。ダイアログに表示するメッセージのIDを設定。
   * messageParam: メッセージに埋め込むパラメーターを設定。
   * cancelButton: string型。CANCELボタンに表示する文言を設定。デフォルト"CANCEL"
   * okButton: string型。OKボタンに表示する文言を設定。デフォルト"OK"
   * showClose: boolean型。CLOSEボタンの表示を設定。デフォルトtrue
   * okButtonId: OKボタンが押下されたときに引き渡されるID値を設定
   * cancelButtonId: CANCELボタンが押下されたときに引き渡されるID値を設定
   * closeButtonId: Xボタンが押下されたときに引き渡されるID値を設定
   * breakLine: '\n'での改行を有効化するためのフラグ。未設定の場合、改行無効
   * @param option 値
   * @param size 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  showConfirmDialogMessageWithParam = (
    option:(m:ViewModel) => any, size:(m:ViewModel) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.SHOW_CONFIRM_DIALOG_MESSAGE_WITH_PARAM,
      option: option,
      size: size,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  scrollToTop = (
    event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.SCROLL_TO_TOP,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  openMenu = (
    event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.OPEN_MENU,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * アプリケーションモデルの指定した項目の値を更新する
   * @param path 画面モデル項目
   * @param value 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  updateViewModel = (
    path:string, value:(m:ViewModel) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.UPDATE_VIEW_MODEL,
      path: path,
      value: value,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * アプリケーションモデルの指定した項目の値をURLパラメータの値で更新する
   * @param path 画面モデル項目
   * @param key 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  updateViewModelWithUrlParameter = (
    path:string, key:(m:ViewModel) => string, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.UPDATE_VIEW_MODEL_WITH_URL_PARAMETER,
      path: path,
      key: key,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * アプリケーションモデルの指定した項目の値をログインユーザIDで更新する
   * @param path 画面モデル項目
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  updateViewModelWithUserId = (
    path:string, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.UPDATE_VIEW_MODEL_WITH_USER_ID,
      path: path,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * アプリケーションモデルの指定した項目の値を事業コードで更新する
   * @param path 画面モデル項目
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  updateViewModelWithBuCd = (
    path:string, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.UPDATE_VIEW_MODEL_WITH_BU_CD,
      path: path,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * アプリケーションモデルの指定した項目の値を事業名で更新する
   * @param path 画面モデル項目
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  updateViewModelWithBuName = (
    path:string, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.UPDATE_VIEW_MODEL_WITH_BU_NAME,
      path: path,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * アプリケーションモデルの指定した項目の値を現在の日付で更新する
   * フォーマットは、"ymd/ym/md"のいずれ
   * @param path 画面モデル項目
   * @param format 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  updateViewModelWithDateNow = (
    path:string, format:(m:ViewModel) => string, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.UPDATE_VIEW_MODEL_WITH_DATE_NOW,
      path: path,
      format: format,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * アプリケーションモデルの指定した項目の値を日付から月数を加えた後の日付で更新する
   * @param path 画面モデル項目
   * @param date 値
   * @param months 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  updateViewModelWithDateAddMonths = (
    path:string, date:(m:ViewModel) => string, months:(m:ViewModel) => number, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.UPDATE_VIEW_MODEL_WITH_DATE_ADD_MONTHS,
      path: path,
      date: date,
      months: months,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * アプリケーションモデルの指定した項目の値を更新する
   * @param path 画面モデル項目
   * @param value 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  mergeViewModel = (
    path:string, value:(m:ViewModel) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.MERGE_VIEW_MODEL,
      path: path,
      value: value,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * アプリケーションモデルの指定した項目の配列に値を追加する
   * @param path 画面モデル項目
   * @param value 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  pushViewModel = (
    path:string, value:(m:ViewModel) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.PUSH_VIEW_MODEL,
      path: path,
      value: value,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * アプリケーションモデルの指定した項目の配列に値を削除する
   * @param path 画面モデル項目
   * @param index 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  deleteViewModelWithRowIndex = (
    path:string, index:(m:ViewModel) => number, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.DELETE_VIEW_MODEL_WITH_ROW_INDEX,
      path: path,
      index: index,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * アプリケーションモデルの指定した項目の値にほかの配列を指定したkeyのマッピングで更新する
   * ※マッピングした後、重複項目も削除される
   * ※マッピングのデータ構造は以下の通り
   *   mapping: {
   *     "origin":string[],
   *     "target":string
   *   }[]
   * ※originには複数のkeyを持つ場合、"-"ですべてのkeyの値を結合して設定
   * @param targetPath 画面モデル項目
   * @param path 画面モデル項目
   * @param mapping 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  updateViewModelWithKeysMapping = (
    targetPath:string, path:string, mapping:(m:ViewModel) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.UPDATE_VIEW_MODEL_WITH_KEYS_MAPPING,
      targetPath: targetPath,
      path: path,
      mapping: mapping,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * アプリケーションモデルの指定した項目の値にほかの配列のあるkeyの値のリストを更新する
   * @param targetPath 画面モデル項目
   * @param path 画面モデル項目
   * @param key 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  updateViewModelWithSelectedKeyValue = (
    targetPath:string, path:string, key:(m:ViewModel) => string, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.UPDATE_VIEW_MODEL_WITH_SELECTED_KEY_VALUE,
      targetPath: targetPath,
      path: path,
      key: key,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * イベントが発生した行番号に対応する表示モデル項目を更新する
   * @param path 画面モデル項目
   * @param value リスト値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  updateViewModelWithIndexedValue = (
    path:string, value:(m:ViewModel, index:number) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.UPDATE_VIEW_MODEL_WITH_INDEXED_VALUE,
      path: path,
      value: value,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * イベントが発生したカラムを全件表示モデルに設定/非設定する
   * @param targetPath 画面モデル項目
   * @param path 画面モデル項目
   * @param checked 画面モデル項目
   * @param selectFlag 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  updateViewModelWithAllValues = (
    targetPath:string, path:string, checked:string, selectFlag:(m:ViewModel) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.UPDATE_VIEW_MODEL_WITH_ALL_VALUES,
      targetPath: targetPath,
      path: path,
      checked: checked,
      selectFlag: selectFlag,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * 選択行情報を全件設定/非設定し、表示モデルに設定/非設定する
   * @param targetPath 画面モデル項目
   * @param parent 画面モデル項目
   * @param checked 画面モデル項目
   * @param selectFlag 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  updateViewModelWithAllRows = (
    targetPath:string, parent:string, checked:string, selectFlag:(m:ViewModel) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.UPDATE_VIEW_MODEL_WITH_ALL_ROWS,
      targetPath: targetPath,
      parent: parent,
      checked: checked,
      selectFlag: selectFlag,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * 活性状態の選択行情報を、表示モデルに設定/非設定する
   * @param targetPath 画面モデル項目
   * @param parent 画面モデル項目
   * @param disabledPath 画面モデル項目
   * @param checked 画面モデル項目
   * @param selectFlag 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  updateViewModelWithActiveRows = (
    targetPath:string, parent:string, disabledPath:string, checked:string, selectFlag:(m:ViewModel) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.UPDATE_VIEW_MODEL_WITH_ACTIVE_ROWS,
      targetPath: targetPath,
      parent: parent,
      disabledPath: disabledPath,
      checked: checked,
      selectFlag: selectFlag,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * イベントが発生した行番号を表示モデル項目に設定する
   * 削除予定
   * @param path 画面モデル項目
   * @param value リスト値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  updateViewModelWithIndexedNumber = (
    path:string, value:(m:ViewModel, index:number) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.UPDATE_VIEW_MODEL_WITH_INDEXED_NUMBER,
      path: path,
      value: value,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * イベントが発生した行番号を表示モデル項目に設定する
   * @param path 画面モデル項目
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  updateViewModelWithIndexNumber = (
    path:string, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.UPDATE_VIEW_MODEL_WITH_INDEX_NUMBER,
      path: path,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * @param path 画面モデル項目
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  updateViewModelWithContent = (
    path:string, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.UPDATE_VIEW_MODEL_WITH_CONTENT,
      path: path,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * 表示モデルによって対応する行の表示モデルを更新する
   * @param index 値
   * @param path 画面モデル項目
   * @param value 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  updateIndexedValueWithViewModel = (
    index:(m:ViewModel) => number, path:string, value:(m:ViewModel) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.UPDATE_INDEXED_VALUE_WITH_VIEW_MODEL,
      index: index,
      path: path,
      value: value,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * 対象テーブルの指定したカラムの表示/非表示を設定する
   * @param path 画面モデル項目
   * @param index 値
   * @param value 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  updateColumnVisibleValue = (
    path:string, index:(m:ViewModel) => number, value:(m:ViewModel) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.UPDATE_COLUMN_VISIBLE_VALUE,
      path: path,
      index: index,
      value: value,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * 対象テーブルの指定した範囲のカラムの表示/非表示を設定する
   * @param path 画面モデル項目
   * @param startIndex 値
   * @param endIndex 値
   * @param value 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  updateColumnsVisibleValue = (
    path:string, startIndex:(m:ViewModel) => number, endIndex:(m:ViewModel) => number, value:(m:ViewModel) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.UPDATE_COLUMNS_VISIBLE_VALUE,
      path: path,
      startIndex: startIndex,
      endIndex: endIndex,
      value: value,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * 対象テーブルの指定した複数カラムの表示/非表示を設定する
   * @param path 画面モデル項目
   * @param index 値
   * @param value 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  updateRangeColumnsVisibleValue = (
    path:string, index:(m:ViewModel) => number[], value:(m:ViewModel) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.UPDATE_RANGE_COLUMNS_VISIBLE_VALUE,
      path: path,
      index: index,
      value: value,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * アプリケーションモデルの指定した項目の内容を初期状態に戻す
   * @param path 画面モデル項目
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  resetViewModel = (
    path:string, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.RESET_VIEW_MODEL,
      path: path,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * 指定した項目の現在の状態のスナップショットを取得し、ローカルストレージ上に保存する。
   * @param path 画面モデル項目
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  takeSnapshotOfViewModel = (
    path:string, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.TAKE_SNAPSHOT_OF_VIEW_MODEL,
      path: path,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * 指定した項目の現在の状態のスナップショットを取得し、セッションストレージ上に保持する。
   * @param path 画面モデル項目
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  takeSnapshotOfViewModelOnSessionStorage = (
    path:string, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.TAKE_SNAPSHOT_OF_VIEW_MODEL_ON_SESSION_STORAGE,
      path: path,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * 指定した項目の現在の状態のスナップショットを取得し、ヒープメモリ上に保持する。
   * @param path 画面モデル項目
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  takeSnapshotOfViewModelOnHeap = (
    path:string, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.TAKE_SNAPSHOT_OF_VIEW_MODEL_ON_HEAP,
      path: path,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * 指定した項目を直近スナップショットの状態に戻す。スナップショットが存在しない場合は、初期状態に戻す。
   * @param path 画面モデル項目
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  resetViewModelToLatestSnapshot = (
    path:string, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.RESET_VIEW_MODEL_TO_LATEST_SNAPSHOT,
      path: path,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * 指定した項目をセッションストレージ上の直近スナップショットの状態に戻す。セッションストレージ上のスナップショットが存在しない場合は、初期状態に戻す。
   * @param path 画面モデル項目
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  resetViewModelToLatestSnapshotOnSessionStorage = (
    path:string, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.RESET_VIEW_MODEL_TO_LATEST_SNAPSHOT_ON_SESSION_STORAGE,
      path: path,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * トーストを指定タイプで表示する。トーストタイプは、"alert"/"basic"/"complete"/"warning"
   * @param value 値
   * @param toastType 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  showToast = (
    value:(m:ViewModel) => any, toastType:(m:ViewModel) => string, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.SHOW_TOAST,
      value: value,
      toastType: toastType,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * イベントが発生したラベル値を表示モデル項目に設定する
   * @param path 画面モデル項目
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  updateViewModelWithSelectedLabelValue = (
    path:string, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.UPDATE_VIEW_MODEL_WITH_SELECTED_LABEL_VALUE,
      path: path,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * イベントが発生したラベル値のリストを表示モデル項目に設定する
   * @param path 画面モデル項目
   * @param all 値
   * @param selectedValues 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  updateViewModelWithSelectedLabelValues = (
    path:string, all:(m:ViewModel) => any, selectedValues:(m:ViewModel) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.UPDATE_VIEW_MODEL_WITH_SELECTED_LABEL_VALUES,
      path: path,
      all: all,
      selectedValues: selectedValues,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * 指定した値で分割し、それぞれをview modelに設定する
   * @param target 値
   * @param splitValue 値
   * @param one 画面モデル項目
   * @param another 画面モデル項目
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  splitValueAndUpdateViewModel = (
    target:(m:ViewModel) => string, splitValue:(m:ViewModel) => string, one:string, another:string, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.SPLIT_VALUE_AND_UPDATE_VIEW_MODEL,
      target: target,
      splitValue: splitValue,
      one: one,
      another: another,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * 今年度の年シーズンを基に、去年度の年シーズンをView Modelに設定する
   * @param tySsn 値
   * @param target 画面モデル項目
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  updateLyBasedOnTy = (
    tySsn:(m:ViewModel) => string, target:string, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.UPDATE_LY_BASED_ON_TY,
      tySsn: tySsn,
      target: target,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * プルダウンの選択候補の指定した要素valueをview modelに設定する
   * @param pulldownList 値
   * @param pulldownIndex 値
   * @param pulldownSelected 画面モデル項目
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  updateViewModelWithPulldownValue = (
    pulldownList:(m:ViewModel) => any, pulldownIndex:(m:ViewModel) => number, pulldownSelected:string, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.UPDATE_VIEW_MODEL_WITH_PULLDOWN_VALUE,
      pulldownList: pulldownList,
      pulldownIndex: pulldownIndex,
      pulldownSelected: pulldownSelected,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * メッセージIDに対応したメッセージ（パラメーターなし）を取得し、トーストを指定タイプで表示する。トーストタイプは、"alert"/"basic"/"complete"/"warning"
   * @param messageId 値
   * @param toastType 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  showToastMessage = (
    messageId:(m:ViewModel) => string, toastType:(m:ViewModel) => string, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.SHOW_TOAST_MESSAGE,
      messageId: messageId,
      toastType: toastType,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * メッセージIDに対応したメッセージ（パラメーターあり）を取得し、トーストを指定タイプで表示する。トーストタイプは、"alert"/"basic"/"complete"/"warning"
   * @param messageId 値
   * @param params 値
   * @param toastType 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  showToastMessageWithParam = (
    messageId:(m:ViewModel) => string, params:(m:ViewModel) => any, toastType:(m:ViewModel) => string, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.SHOW_TOAST_MESSAGE_WITH_PARAM,
      messageId: messageId,
      params: params,
      toastType: toastType,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * アプリケーションモデルの指定した項目をメッセージエリアに表示する
   * @param path 画面モデル項目
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  showErrorMessageWithViewModel = (
    path:string, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.SHOW_ERROR_MESSAGE_WITH_VIEW_MODEL,
      path: path,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * アプリケーションモデルの指定した項目の配列に値のディープコピーを追加する
   * @param path 画面モデル項目
   * @param value 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  pushValuesToViewModel = (
    path:string, value:(m:ViewModel) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.PUSH_VALUES_TO_VIEW_MODEL,
      path: path,
      value: value,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * アプリケーションモデルの指定した項目の配列をキー項目でフィルタし、対象の配列に移動する
   * @param recordsPath 画面モデル項目
   * @param key 値
   * @param value 値
   * @param targetPath 画面モデル項目
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  moveValuesToViewModel = (
    recordsPath:string, key:(m:ViewModel) => string, value:(m:ViewModel) => any, targetPath:string, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.MOVE_VALUES_TO_VIEW_MODEL,
      recordsPath: recordsPath,
      key: key,
      value: value,
      targetPath: targetPath,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * スプレッドの指定したセルの値を更新する
   * @param path 画面モデル項目
   * @param row 値
   * @param col 値
   * @param value 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  updateSpreadsheetCellValue = (
    path:string, row:(m:ViewModel) => number, col:(m:ViewModel) => number, value:(m:ViewModel) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.UPDATE_SPREADSHEET_CELL_VALUE,
      path: path,
      row: row,
      col: col,
      value: value,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * スプレッドの指定した列目の値を一括更新する
   * @param path 画面モデル項目
   * @param col 値
   * @param value 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  updateSpreadsheetColumnValue = (
    path:string, col:(m:ViewModel) => number, value:(m:ViewModel) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.UPDATE_SPREADSHEET_COLUMN_VALUE,
      path: path,
      col: col,
      value: value,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * 指定された日付の週頭日を設定する
   * @param selected 値
   * @param path 画面モデル項目
   * @param fmt 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  updateByStartWeekDate = (
    selected:(m:ViewModel) => string, path:string, fmt:(m:ViewModel) => string, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.UPDATE_BY_START_WEEK_DATE,
      selected: selected,
      path: path,
      fmt: fmt,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

  /**
   * @param authAIMUserInfo 値
   * @param event このアクションの起因イベント
   * @param desc このアクションの詳細說明(デバッグ用)
   */
  setAuthAimUserInfo = (
    authAIMUserInfo:(m:ViewModel) => any, event:UIEvent<any>, desc:string
  ):UIAction => {
    return {
      type: UIAction.SET_AUTH_AIM_USER_INFO,
      authAIMUserInfo: authAIMUserInfo,
      event: event,
      desc: desc,
      nav: () => this.nav,
      modal: () => this.modal,
      toast: () => this.toast,
      closeModal: () => this.closeModal,
      restClient: this.restClient,
      eventHub: () => this.eventHub,
      auth: () => this.auth,
      systemMessage: () => this.systemMessage,
      loading: () => this.loading,
      selectedGbuCD: () => this.selectedGbuCD,
    }
  }

}

/**
 * アクション実行定義
 * @param model アプリケーションステート
 * @param action アクションオブジェクト
 */
export function reducer(model:ViewModel = ViewModel.getInitialState(), action:UIAction) {
  switch (action.type) {
    // 【API呼び出し:apiCall:ApiCall】を呼び出す
    case UIAction.CALL_API:
      return ((model, {apiCall}):ViewModel => {
        if (action.event.source instanceof File) {
          action.restClient.send(apiCall, model, action.event.source)
        }
        else {
          action.restClient.send(apiCall, model)
        }
        return model
      })(model, action)

    // 【画面モデル項目:path:string】に【値:value:(m:ViewModel) => any】を加えて再検索する
    case UIAction.RE_SEARCH_TABLE:
      return ((model, {path, value}):ViewModel => {
        let v = ViewModel.get(path, model)
        model = ViewModel.update(path, v + value(model), model)
        action.restClient.send(action.restClient.call__pre, model)
        return model
      })(model, action)

    // 【API呼び出し:apiCall:ApiCall】の結果を画面に反映する
    case UIAction.APPLY_API_RESULT:
      return ((model, {apiCall}):ViewModel => {
        const body:any = action.event.source.jsonBody
        return apiCall.updateWithResponse(model, body)
      })(model, action)

    // 【API呼び出し:apiCall:ApiCall】の結果を画面にマージする
    case UIAction.MERGE_API_RESULT:
      return ((model, {apiCall}):ViewModel => {
        const body:any = action.event.source.jsonBody
        return apiCall.updateWithResponse(model, body, true)
      })(model, action)

    // APIの応答内容を画面に反映する
    case UIAction.SHOW_API_RESPONSE:
      return ((model, {}):ViewModel => {
        const apiCall = action.event.source.apiCall
        const body = action.event.source.jsonBody
        return apiCall.updateWithResponse(model, body)
      })(model, action)

    // ユーザエラーの内容を画面に反映する
    case UIAction.SHOW_API_USER_ERROR:
      return ((model, {}):ViewModel => {
        const apiCall = action.event.source.apiCall
        const body = action.event.source.jsonBody
        model = apiCall.updateWithUserError(model, body)
        if ((model.errorMessages || []).filter(e => e.modelPath === '_common_').length > 0
          || (model.modalErrorMessages || []).filter(e => e.modelPath === '_common_').length > 0) {
          const toast = action.toast().createAlert('Error occurred.')
          toast.present();
        }
        return model
      })(model, action)

    // ユーザエラーの内容をクリアする
    case UIAction.RESET_USER_ERROR:
      return ((model, {}):ViewModel => {
        return ViewModel.update('errorMessages', [], model)
      })(model, action)

    // ユーザワーニングの内容を画面に反映する
    case UIAction.SHOW_API_USER_WARNING:
      return ((model, {}):ViewModel => {
        const apiCall = action.event.source.apiCall
        const body = action.event.source.jsonBody
        return apiCall.updateWithUserWarning(model, body)
      })(model, action)

    // レスポンスの内容をファイル名【値:filename:(m:ViewModel) => any】として保存する
    case UIAction.SAVE_RESPONSE_AS_FILE:
      return ((model, {filename}):ViewModel => {
        const apiCall = action.event.source.apiCall
        const response = action.event.source.response
        response.blob().then(blob => download(blob, filename(model)))
        return model
      })(model, action)

    // グローバルオフィシャルレスポンスの内容を検索条件"年シーズン"【値:yrSsnName:(m:ViewModel) => any】、"部門"【値:gDept:(m:ViewModel) => any】、ファイル名【値:filename:(m:ViewModel) => any】として保存する
    case UIAction.SAVE_GLOBAL_OFFICIAL_RESPONSE_AS_FILE:
      return ((model, {yrSsnName, gDept, filename}):ViewModel => {
        const apiCall = action.event.source.apiCall;
        const response = action.event.source.response;
        const yrSsn:string = yrSsnName(model);
        const yr: string = yrSsn.split('-')[0].substring(2,4);
        const ssn: string = yrSsn.split('-')[1];
        let gDeptList: string[] = [];
        gDept(model).forEach(gdept => {
          let gDeptCd:string = gdept.split(':')[0];
          gDeptList.push(gDeptCd);
        });
        const gDeptCd:string = gDeptList.join('&');
        const globalFileName:string = yr + ssn + '_Div' + gDeptCd + filename(model);
        response.blob().then(blob => download(blob, globalFileName));
        return model;
      })(model, action)

    // ローカルオフィシャルレスポンスの内容を検索条件"年シーズン"【値:yrSsnName:(m:ViewModel) => any】、"事業"【値:buName:(m:ViewModel) => any】、"地域"【値:rgnName:(m:ViewModel) => any】、"部門"【値:gDept:(m:ViewModel) => any】、ファイル名【値:filename:(m:ViewModel) => any】として保存する
    case UIAction.SAVE_LOCAL_OFFICIAL_RESPONSE_AS_FILE:
      return ((model, {yrSsnName, buName, rgnName, gDept, filename}):ViewModel => {
        const apiCall = action.event.source.apiCall;
        const response = action.event.source.response;
        const yrSsn:string = yrSsnName(model);
        const yr: string = yrSsn.split("-")[0].substring(2,4);
        const ssn: string = yrSsn.split("-")[1];
        const bu: string = buName(model);
        const rgn: string = rgnName(model);
        const buRgn: string = rgn === '-' ? bu : bu + ' ' + rgn;
        const gDeptList: string[] = gDept(model).map(a => {
          let gDeptCd:string = a.split(':')[0];
          return gDeptCd;
        })
        const gDeptCd:string = gDeptList.join('&');
        const localFileName:string = yr + ssn + '_' + buRgn + '_Div' + gDeptCd + filename(model);
        response.blob().then(blob => download(blob, localFileName));
        return model;
      })(model, action)

    // 週別集約販売在庫計画レスポンスの内容を検索条件"事業"【値:buName:(m:ViewModel) => any】、"地域"【値:rgnName:(m:ViewModel) => any】、"部門"【値:gDept:(m:ViewModel) => any】、ファイル名【値:filename:(m:ViewModel) => any】として保存する
    case UIAction.SAVE_WEEKLY_SALES_INVENTORY_RESPONSE_AS_FILE:
      return ((model, {buName, rgnName, gDept, filename}):ViewModel => {
        const apiCall = action.event.source.apiCall;
        const response = action.event.source.response;
        const bu: string = buName(model);
        const rgn: string = rgnName(model);
        const buRgn: string = rgn === '-' ? bu : bu + '_' + rgn;
        const gDeptList: any[] = gDept(model);
        const gDeptSelected: number = gDeptList.filter(g => g.selected).length;
        const gDeptNotSelected: number = gDeptList.filter(g => !g.selected).length;
        let gDeptCd: string = '';
        if (gDeptList.length === gDeptSelected || gDeptList.length === gDeptNotSelected) {
          gDeptCd = 'ALL';
        } else {
          const gDeptLabelList: string[] = gDeptList.filter(g => g.selected).map(g => g.label);
          const gDeptIdList: string[] = [];
          gDeptLabelList.forEach(g => {
            let gDeptId: string = g.split(':')[0];
            gDeptIdList.push(gDeptId);
          });
          gDeptCd = gDeptIdList.join('&');
        }
        const localFileName:string = buRgn + '_Div' + gDeptCd + filename(model);
        response.blob().then(blob => download(blob, localFileName));
        return model;
      })(model, action)

    // SKU販売在庫計画レスポンスの内容を検索条件"事業"【値:buName:(m:ViewModel) => any】、"地域"【値:rgnName:(m:ViewModel) => any】、"販売集約コード"【値:slsSumCd:(m:ViewModel) => any】、"販売集約名"【値:slsSumName:(m:ViewModel) => any】、ファイル名【値:filename:(m:ViewModel) => any】として保存する
    case UIAction.SAVE_SKU_SALES_INVENTORY_RESPONSE_AS_FILE:
      return ((model, {buName, rgnName, slsSumCd, slsSumName, filename}):ViewModel => {
        const apiCall = action.event.source.apiCall;
        const response = action.event.source.response;
        const bu: string = buName(model);
        const rgn: string = rgnName(model);
        const buRgn: string = rgn === '-' ? bu : bu + '_' + rgn;
        const reqSlsSumCd: string = slsSumCd(model);
        const reqSlsSumName: string = slsSumName(model);
        const localFileName:string = buRgn + '_' + reqSlsSumCd + '_' + reqSlsSumName + filename(model);
        response.blob().then(blob => download(blob, localFileName));
        return model;
      })(model, action)

    // レスポンスの内容をファイル名【値:filename:(m:ViewModel) => any】としてJSON保存する
    case UIAction.SAVE_RESPONSE_AS_JSON:
      return ((model, {filename}):ViewModel => {
        const response = action.event.source.jsonBody
        download(new Blob([JSON.stringify({
          apiResponse: response.apiResponse,
          apiResponseHash: response.apiResponseHash
        })], { type: 'application/json' }), filename(model))
        return model
      })(model, action)

    // REST APIレスポンスの内容をファイル名【値:filename:(m:ViewModel) => any】としてJSON保存する
    case UIAction.SAVE_REST_API_RESPONSE_AS_JSON:
      return ((model, {filename}):ViewModel => {
        const response = action.event.source.jsonBody
        download(new Blob([JSON.stringify({
          apiResponse: response
        })], { type: 'application/json' }), filename(model))
        return model
      })(model, action)

    // 【遷移先画面名:pageName:(m:ViewModel) => string】に遷移する
    case UIAction.MOVE_TO_PAGE:
      return ((model, {pageName}):ViewModel => {
        model = ViewModel.update('errorMessages', [], model)
        action.nav().push(pageName(model))
        return model
      })(model, action)

    // 前の画面に遷移する
    case UIAction.BACK_TO_PREV_PAGE:
      return ((model, {}):ViewModel => {
        model = ViewModel.update('errorMessages', [], model)
        action.nav().pop()
        return model
      })(model, action)

    // 【画面モデル項目:redirectHostNamePath:string】【値:redirectPage:(m:ViewModel) => string】にリダイレクトする
    case UIAction.REDIRECT_TO_PAGE:
      return ((model, {redirectHostNamePath, redirectPage}):ViewModel => {
        const redirectPathExpr = ViewModel.get(redirectHostNamePath, model);
        if (!redirectPathExpr) return model
        const [redirectPageName, redirectContext] = redirectPathExpr.split("/")
        let redirectUrl;
        switch (redirectPageName) {
          case 'official_plan':
          case 'sales_inventory_plan':
            redirectUrl = ENV.SALESPLN_FRONTEND;
            break;
          case 'production':
          case 'order':
          case 'raw_material_plan':
          case 'material_management':
            redirectUrl = ENV.MATERIALPROD_FRONTEND;
            break;
          case 'inventory_control':
            redirectUrl = ENV.STRPLNINVCNTL_FRONTEND;
            break;
          case 'ariake_inventory_management':
            redirectUrl = ENV.AIM_FRONTEND;
            break;
          case 'common':
            redirectUrl = ENV.CMNFNC_FRONTEND;
            break;
        }
        if (redirectUrl.slice(-1) !== '/' && redirectUrl.slice(-4) !== 'html') {
          redirectUrl = redirectUrl + '/';
        }
        const [protocol, redirectHost, ...redirectRelPath] = redirectUrl.split(/\/(?=[^/])/)
        const parentRelPath = redirectRelPath.slice(0, -1)
        const resourceName = redirectRelPath.slice(-1)[0]
        window.top.location.href = protocol + '/'
                                 + (redirectHost + '/'
                                 + parentRelPath.join("/") + '/'
                                 + (!redirectContext ? "" : (redirectContext + '/')) + '/'
                                 + resourceName
                                 + '#/'
                                 + redirectPage(model)).replace(/\/+/g, "/");
        return model
      })(model, action)

    // 【遷移先画面名:pageName:(m:ViewModel) => string】にモーダル遷移する【値:size:(m:ViewModel) => any】
    case UIAction.MOVE_TO_MODAL_PAGE:
      return ((model, {pageName, size}):ViewModel => {
          let css;
          switch (size(model)) {
            case 's':
              css = 'modal-small';
              break;
            case 'm':
              css = 'modal-medium';
              break;
            case 'l':
              css = 'modal-large';
              break;
          }
          const modal = action.modal().create(pageName(model), undefined, {
            cssClass: css,
            enableBackdropDismiss: false
          })
          model = ViewModel.update('modalErrorMessages', [], model)
          modal.present()
          return model
      })(model, action)

    // モーダルを閉じる
    case UIAction.CLOSE_MODAL_PAGE:
      return ((model, {}):ViewModel => {
        action.closeModal()
        return model
      })(model, action)

    // オプション【値:option:(m:ViewModel) => any】の確認ダイアログを表示する【値:size:(m:ViewModel) => any】
    case UIAction.SHOW_CONFIRM_DIALOG:
      return ((model, {option, size}):ViewModel => {
        let css;
        switch (size(model)) {
          case 's':
            css = 'dialog-small';
            break;
          case 'm':
            css = 'dialog-medium';
            break;
          case 'l':
            css = 'dialog-large';
            break;
        }
        let options = option(model);
        const params = {
          title: options.title,
          message: options.message,
          cancelButtonTitle: options.cancelButton || 'CANCEL',
          okButtonTitle: options.okButton || 'OK',
          showCloseButton: (options.showClose == null) ? true : options.showClose,
          showDeleteButton: options.deleteButton || false,
          breakLine: !!options.breakLine ? options.breakLine : false
        };
        const myModalOptions: ModalOptions = {
          showBackdrop: false,
          enableBackdropDismiss: false,
          cssClass: css
        };
        const modal = action.modal().create(ConfirmDialogPage, params, myModalOptions);
        modal.onDidDismiss(data => {
          console.log(data);
          let target: string = '';
          if (data.value === 'ok') {
            target = options.okButtonId
          } else if (data.value === 'cancel') {
            target = options.cancelButtonId
          } else if (data.value === 'close') {
            target = options.closeButtonId
          }
          action.eventHub().next({
            id: target,
            type: data.event.type,
            source: {},
            index: "" 
          });
        });
        modal.present();
        return model
      })(model, action)

    // URL【値:url:(m:ViewModel) => any】の新規ウィンドウを開く
    case UIAction.OPEN_NEW_WINDOW:
      return ((model, {url}):ViewModel => {
        if (!!url(model)) {
          window.open(url(model).startsWith("http") ? url(model) : "http://" + url(model), "_blank", "menubar=no,location=no,status=no,toolbar=no")
        }
        return model
      })(model, action)

    // ユーザワーニングのダイアログを表示する
    case UIAction.SHOW_WARNING_DIALOG:
      return ((model, {}):ViewModel => {
        let css = 'dialog-small'
        let warningMessages = ViewModel.get('warningMessages', model) || {}
        let messages = warningMessages.messages || []
        let ignoreWarning = warningMessages.ignoreWarning || {}
        const params = {
          title: 'Warning Message',
          message: messages.filter(m => !ignoreWarning[m.id]).map(m => m.id+':'+m.message).join('  '),
          cancelButtonTitle: 'CANCEL',
          okButtonTitle: 'CONTINUE',
          showCloseButton: false
        };
        const myModalOptions: ModalOptions = {
          showBackdrop: false,
          enableBackdropDismiss: false,
          cssClass: css
        };
        const modal = action.modal().create(ConfirmDialogPage, params, myModalOptions);
        modal.onDidDismiss(data => {
          if (data.value === 'ok') {
            messages.forEach(m => {
              ignoreWarning[m.id] = true
            })
            action.restClient().send(action.restClient().call__pre, model, null, ignoreWarning)
          }
        });
        modal.present();
        return model
      })(model, action)

    // 【画面モデル項目:selectedGbuCdPath:string】を用い認可情報を取得する
    case UIAction.REACQUIRE_AUTH_INFO:
      return ((model, {selectedGbuCdPath}):ViewModel => {
        action.loading().showLoading = true;
        const selectedGbuCd = ViewModel.get(selectedGbuCdPath, model);
        Observable.forkJoin([
          action.auth().getAuthActionInfo(selectedGbuCd),
          action.auth().getAuthMenuInfo(selectedGbuCd)
        ]).subscribe(() => {
          window.top.location.href = ENV.DASHBOARD_FRONTEND
        });
        return model
      })(model, action)

    // 【画面モデル項目:selectedBuCdPath:string】を用いAIM用画面項目認可情報を取得する
    case UIAction.REACQUIRE_AIM_AUTH_INFO:
      return ((model, {selectedBuCdPath}):ViewModel => {
        action.loading().showLoading = true;
        const selectedBuCd = ViewModel.get(selectedBuCdPath, model);
        Observable.forkJoin([
          action.auth().getAuthActionInfo('', selectedBuCd, AuthorizationService.BLNG_TYPE_CD_BUSINESS),
          action.auth().getAuthMenuInfo('', selectedBuCd, AuthorizationService.BLNG_TYPE_CD_BUSINESS)
        ]).subscribe(() => {
          window.top.location.href = ENV.DASHBOARD_FRONTEND
        })
        return model
      })(model, action)

    // メッセージID指定でオプション【値:option:(m:ViewModel) => any】の確認ダイアログを表示する【値:size:(m:ViewModel) => any】
    case UIAction.SHOW_CONFIRM_DIALOG_MESSAGE:
      return ((model, {option, size}):ViewModel => {
        let css;
        switch (size(model)) {
          case 's':
            css = 'dialog-small';
            break;
          case 'm':
            css = 'dialog-medium';
            break;
          case 'l':
            css = 'dialog-large';
            break;
        }
        let options = option(model);
        let messageText = action.systemMessage().textOf(options.messageId, {});
        const params = {
          title: options.title,
          message: messageText,
          cancelButtonTitle: options.cancelButton || 'CANCEL',
          okButtonTitle: options.okButton || 'OK',
          showCloseButton: (options.showClose == null) ? true : options.showClose,
          showDeleteButton: options.deleteButton || false,
          breakLine: !!options.breakLine ? options.breakLine : false
        };
        const myModalOptions: ModalOptions = {
          showBackdrop: false,
          enableBackdropDismiss: false,
          cssClass: css
        };
        const modal = action.modal().create(ConfirmDialogPage, params, myModalOptions);
        modal.onDidDismiss(data => {
          console.log(data);
          let target: string = '';
          if (data.value === 'ok') {
            target = options.okButtonId
          } else if (data.value === 'cancel') {
            target = options.cancelButtonId
          } else if (data.value === 'close') {
            target = options.closeButtonId
          }
          action.eventHub().next({
            id: target,
            type: data.event.type,
            source: {},
            index: "" 
          });
        });
        modal.present();
        return model
      })(model, action)

    // メッセージIDとパラメーター指定でオプション【値:option:(m:ViewModel) => any】の確認ダイアログを表示する【値:size:(m:ViewModel) => any】
    case UIAction.SHOW_CONFIRM_DIALOG_MESSAGE_WITH_PARAM:
      return ((model, {option, size}):ViewModel => {
        let css;
        switch (size(model)) {
          case 's':
            css = 'dialog-small';
            break;
          case 'm':
            css = 'dialog-medium';
            break;
          case 'l':
            css = 'dialog-large';
            break;
        }
        let options = option(model);
        let messageText = action.systemMessage().textOf(options.messageId, options.messageParam);
        const params = {
          title: options.title,
          message: messageText,
          cancelButtonTitle: options.cancelButton || 'CANCEL',
          okButtonTitle: options.okButton || 'OK',
          showCloseButton: (options.showClose == null) ? true : options.showClose,
          showDeleteButton: options.deleteButton || false,
          breakLine: !!options.breakLine ? options.breakLine : false
        };
        const myModalOptions: ModalOptions = {
          showBackdrop: false,
          enableBackdropDismiss: false,
          cssClass: css
        };
        const modal = action.modal().create(ConfirmDialogPage, params, myModalOptions);
        modal.onDidDismiss(data => {
          console.log(data);
          let target: string = '';
          if (data.value === 'ok') {
            target = options.okButtonId
          } else if (data.value === 'cancel') {
            target = options.cancelButtonId
          } else if (data.value === 'close') {
            target = options.closeButtonId
          }
          action.eventHub().next({
            id: target,
            type: data.event.type,
            source: {},
            index: "" 
          });
        });
        modal.present();
        return model
      })(model, action)

    // メイン画面最上部までスクロールする
    case UIAction.SCROLL_TO_TOP:
      return ((model, {}):ViewModel => {
        document.querySelector("ion-nav.split-pane-main .ion-page ion-content div.scroll-content").scrollTop = 0;
        return model;
      })(model, action)

    // メニューを開く
    case UIAction.OPEN_MENU:
      return ((model, {}):ViewModel => {
        action.menu().open()
        return model
      })(model, action)

    // 【画面モデル項目:path:string】に【値:value:(m:ViewModel) => any】を設定する
    case UIAction.UPDATE_VIEW_MODEL:
      return ((model, {path, value}):ViewModel => {
        return ViewModel.update(path, value(model), model)
      })(model, action)

    // 【画面モデル項目:path:string】にURLパラメータ【値:key:(m:ViewModel) => string】を設定する
    case UIAction.UPDATE_VIEW_MODEL_WITH_URL_PARAMETER:
      return ((model, {path, key}):ViewModel => {
        const searchObj = {};
        let searchStr = location.search;
        searchStr = searchStr.slice(1, searchStr.length);
        searchStr.split('&').forEach(search => {
          const keyValue = search.split('=');
          searchObj[keyValue[0]] = keyValue[1]
        });
        return ViewModel.update(path, searchObj[key(model)], model)
      })(model, action)

    // 【画面モデル項目:path:string】にユーザIDを設定する
    case UIAction.UPDATE_VIEW_MODEL_WITH_USER_ID:
      return ((model, {path}):ViewModel => {
        return ViewModel.update(path, AuthorizationService.AUTH_USER_ID, model)
      })(model, action)

    // 【画面モデル項目:path:string】に事業コードを設定する
    case UIAction.UPDATE_VIEW_MODEL_WITH_BU_CD:
      return ((model, {path}):ViewModel => {
        return ViewModel.update(path, action.auth().getSelectedBuCD(), model)
      })(model, action)

    // 【画面モデル項目:path:string】に事業名を設定する
    case UIAction.UPDATE_VIEW_MODEL_WITH_BU_NAME:
      return ((model, {path}):ViewModel => {
        let authAIMUserInfo = action.auth().getAuthAIMUserInfo();
        let selectedBuCd = action.auth().getSelectedBuCD();
        let selectedBu = !!authAIMUserInfo ? authAIMUserInfo.filter(item => item.value == selectedBuCd) : null;
        return ViewModel.update(path, !!selectedBu ? selectedBu[0].label : '', model);
      })(model, action)

    // 【画面モデル項目:path:string】に現在日付を【値:format:(m:ViewModel) => string】のフォーマットで設定する
    case UIAction.UPDATE_VIEW_MODEL_WITH_DATE_NOW:
      return ((model, {path, format}):ViewModel => {
        const dt = new Date();
        const year = dt.getFullYear();
        const month = ('0' + (dt.getMonth() + 1)).slice(-2);
        const date = ('0' + dt.getDate()).slice(-2);
        const fmt = format(model)
        let now;
        if (fmt === 'ym') {
          now = year + '/' + month;
        } else if (fmt === 'md') {
          now = month + '/' + date;
        } else {
          now = year + '/' + month + '/' + date;
        }
        return ViewModel.update(path, now, model)
      })(model, action)

    // 【画面モデル項目:path:string】に日付【値:date:(m:ViewModel) => string】を【値:months:(m:ViewModel) => number】ヶ月を加えて設定する
    case UIAction.UPDATE_VIEW_MODEL_WITH_DATE_ADD_MONTHS:
      return ((model, {path, date, months}):ViewModel => {
        const ymd = date(model).split('/');
        const dt = new Date();
        let format;
        if (/[0-9][0-9][0-9][0-9]\/[0-1][0-9]\/[0-3][0-9]/.test(date(model))) {
          dt.setFullYear(Number(ymd[0]));
          dt.setMonth(Number(ymd[1]) - 1);
          dt.setDate(Number(ymd[2]));
          format = 'ymd';
        } else if (/[0-9][0-9][0-9][0-9]\/[0-1][0-9]/.test(date(model))) {
          dt.setFullYear(Number(ymd[0]));
          dt.setMonth(Number(ymd[1]) - 1);
          dt.setDate(1);
          format = 'ym';
        } else if (/[0-1][0-9]\/[0-3][0-9]/.test(date(model))) {
          dt.setMonth(Number(ymd[0]) - 1);
          dt.setDate(Number(ymd[1]));
          format = 'md';
        } else {
          return;
        }
        // add months
        dt.setMonth(dt.getMonth() + months(model));
        let dateNew;
        if (format === 'ymd') {
          dateNew = dt.getFullYear() + '/' + ('0' + (dt.getMonth() + 1)).slice(-2) + '/' + ('0' + dt.getDate()).slice(-2);
        }
        if (format === 'ym') {
          dateNew = dt.getFullYear() + '/' + ('0' + (dt.getMonth() + 1)).slice(-2);
        }
        if (format === 'md') {
          dateNew = ('0' + (dt.getMonth() + 1)).slice(-2) + '/' + ('0' + dt.getDate()).slice(-2);
        }
        
        return ViewModel.update(path, dateNew, model)
      })(model, action)

    // 【画面モデル項目:path:string】に【値:value:(m:ViewModel) => any】をマージする
    case UIAction.MERGE_VIEW_MODEL:
      return ((model, {path, value}):ViewModel => {
        return ViewModel.merge(path, value(model), model)
      })(model, action)

    // 【画面モデル項目:path:string】に【値:value:(m:ViewModel) => any】を追加する
    case UIAction.PUSH_VIEW_MODEL:
      return ((model, {path, value}):ViewModel => {
        let targetList = ViewModel.get(path, model);
        if (Array.isArray(targetList)) {
          targetList.push(value(model));
          return ViewModel.update(path, targetList, model);
        } else {
          return;
        }
      })(model, action)

    // 【画面モデル項目:path:string】の【値:index:(m:ViewModel) => number】番目のデータを削除する
    case UIAction.DELETE_VIEW_MODEL_WITH_ROW_INDEX:
      return ((model, {path, index}):ViewModel => {
        let targetList = ViewModel.get(path, model);
        if (Array.isArray(targetList) && targetList.length > index(model)) {
          targetList.splice(index(model), 1);
          return ViewModel.update(path, targetList, model);
        } else {
          return;
        }
      })(model, action)

    // 【画面モデル項目:targetPath:string】に【画面モデル項目:path:string】を【値:mapping:(m:ViewModel) => any】でマッピングする
    case UIAction.UPDATE_VIEW_MODEL_WITH_KEYS_MAPPING:
      return ((model, {targetPath, path, mapping}):ViewModel => {
        let list = ViewModel.get(path, model)
        let mappingList = mapping(model)
        if (Array.isArray(list) && Array.isArray(mappingList)) {
          let targetList = list.map(e => {
            let target = {}
            mappingList.forEach(keys => {
              target[keys.target] = keys.origin.map(key => e[key]).join('-')
            })
            return target
          }).filter((e, i, self) => self.findIndex(x => mappingList.map(mapping => mapping.target).every(key => e[key] === x[key])) === i);
          return ViewModel.update(targetPath, targetList, model)
        }
      })(model, action)

    // 【画面モデル項目:targetPath:string】に【画面モデル項目:path:string】の【値:key:(m:ViewModel) => string】の全レコードを設定する
    case UIAction.UPDATE_VIEW_MODEL_WITH_SELECTED_KEY_VALUE:
      return ((model, {targetPath, path, key}):ViewModel => {
        let list = ViewModel.get(path, model);
        let targetList = [];
        if (Array.isArray(list)) {
          list.forEach(e => {
            targetList.push(e[key(model)]);
          })
        }
        return ViewModel.update(targetPath, targetList, model)
      })(model, action)

    // 【画面モデル項目:path:string】に当該行の【リスト値:value:(m:ViewModel, index:number) => any】を設定する
    case UIAction.UPDATE_VIEW_MODEL_WITH_INDEXED_VALUE:
      return ((model, {path, value}):ViewModel => {
        const i = action.event.index
        return ViewModel.update(path, value(model, i), model)
      })(model, action)

    // 【画面モデル項目:targetPath:string】に【画面モデル項目:path:string】を全件設定し【画面モデル項目:checked:string】を【値:selectFlag:(m:ViewModel) => any】状態にする
    case UIAction.UPDATE_VIEW_MODEL_WITH_ALL_VALUES:
      return ((model, {targetPath, path, checked, selectFlag}):ViewModel => {
        const pathList:string[] = path.split('.')
        const child:string = pathList[pathList.length - 1]
        const checkId:string = checked.split('.')[checked.split('.').length - 1]
        const parentPathList:string[] = pathList.slice(0, -2)
        const parentPath:string = parentPathList.join('.')
        const allValue = JSON.parse(JSON.stringify(ViewModel.get(parentPath, model)))
          let targetValue: string[] = []
          if (!!selectFlag(model)) {
            targetValue = allValue.map((v) => {
              return v[child]
            })
          }
        
          const targetAllValue = allValue.map((v) => {
            v[checkId] = selectFlag(model)
            return v
          })
          ViewModel.update(parentPath, targetAllValue, model)
          return ViewModel.update(targetPath, targetValue, model)
      })(model, action)

    // 【画面モデル項目:targetPath:string】に【画面モデル項目:parent:string】の選択行情報を設定し、【画面モデル項目:checked:string】を【値:selectFlag:(m:ViewModel) => any】に設定する
    case UIAction.UPDATE_VIEW_MODEL_WITH_ALL_ROWS:
      return ((model, {targetPath, parent, checked, selectFlag}):ViewModel => {
        let target: any[] = [];
        const records = JSON.parse(JSON.stringify(ViewModel.get(parent, model)));
        if (!!selectFlag(model)) {
          target = records.map((each, index) => {
            each.rowIndex = index;
            return each;
          });
        } else {
          target = [];
        }
        const checkId:string = checked.split('.')[checked.split('.').length - 1];
        const allChecked = records.map((record) => {
          record[checkId] = selectFlag(model);
          return record;
        });
        ViewModel.update(targetPath, target, model);
        return ViewModel.update(parent, allChecked, model);
      })(model, action)

    // 【画面モデル項目:targetPath:string】に【画面モデル項目:parent:string】が活性状態【画面モデル項目:disabledPath:string】の選択行情報を設定し、【画面モデル項目:checked:string】を【値:selectFlag:(m:ViewModel) => any】に設定する
    case UIAction.UPDATE_VIEW_MODEL_WITH_ACTIVE_ROWS:
      return ((model, {targetPath, parent, disabledPath, checked, selectFlag}):ViewModel => {
        let target: any[] = [];
        const disabledRow:string = disabledPath.split('.')[disabledPath.split('.').length - 1];
          const records = JSON.parse(JSON.stringify(ViewModel.get(parent, model)));
          if (!!selectFlag(model)) {
            target = records.map((each, index) => {
              if (!each[disabledRow]) {
                each.rowIndex = index;
                return each;
              }
            });
            target = target.filter(each => !!each);
          } else {
            target = [];
          }
          const checkId:string = checked.split('.')[checked.split('.').length - 1];
          const allChecked = records.map((record) => {
            if (!record[disabledRow]) {
              record[checkId] = selectFlag(model);
              return record;
            } else {
              return record;
            }
          });
          ViewModel.update(targetPath, target, model);
          return ViewModel.update(parent, allChecked, model);
      })(model, action)

    // 【画面モデル項目:path:string】に【リスト値:value:(m:ViewModel, index:number) => any】行番号を設定する
    case UIAction.UPDATE_VIEW_MODEL_WITH_INDEXED_NUMBER:
      return ((model, {path, value}):ViewModel => {
        const i = action.event.index
        return ViewModel.update(path, i, model)
      })(model, action)

    // 【画面モデル項目:path:string】にその行の番号を設定する
    case UIAction.UPDATE_VIEW_MODEL_WITH_INDEX_NUMBER:
      return ((model, {path}):ViewModel => {
        const i = action.event.index
        return ViewModel.update(path, i, model)
      })(model, action)

    // 【画面モデル項目:path:string】にその内容を設定する
    case UIAction.UPDATE_VIEW_MODEL_WITH_CONTENT:
      return ((model, {path}):ViewModel => {
        const content = action.event.source.value
        return ViewModel.update(path, content, model)
      })(model, action)

    // 行番号【値:index:(m:ViewModel) => number】番目の【画面モデル項目:path:string】に【値:value:(m:ViewModel) => any】を設定する
    case UIAction.UPDATE_INDEXED_VALUE_WITH_VIEW_MODEL:
      return ((model, {index, path, value}):ViewModel => {
        const i = index(model)
        const pathList:string[] = path.split('.')
        const childPath:string = pathList[pathList.length - 1]
        const parentPathList = pathList.slice(0, -2)
        const parentPath:string = parentPathList.join('.')
        const target:string = [parentPath,i,childPath].join('.')
        return ViewModel.update(target, value(model), model)
      })(model, action)

    // 【画面モデル項目:path:string】の【値:index:(m:ViewModel) => number】列目表示状態を【値:value:(m:ViewModel) => any】に設定する
    case UIAction.UPDATE_COLUMN_VISIBLE_VALUE:
      return ((model, {path, index, value}):ViewModel => {
        const i: number = index(model);
        const updated = JSON.parse(JSON.stringify(ViewModel.get(path, model))) || [];
        updated.map((u) => {
          if (u.index === i) {
            u.conditions = value(model);
          }
        });
        return ViewModel.update(path, updated, model);
      })(model, action)

    // 【画面モデル項目:path:string】の【値:startIndex:(m:ViewModel) => number】列目から【値:endIndex:(m:ViewModel) => number】列目までの表示状態を【値:value:(m:ViewModel) => any】に設定する
    case UIAction.UPDATE_COLUMNS_VISIBLE_VALUE:
      return ((model, {path, startIndex, endIndex, value}):ViewModel => {
        const start: number = startIndex(model);
        const end: number = endIndex(model);
        const updated = JSON.parse(JSON.stringify(ViewModel.get(path, model))) || [];
        updated.map((u) => {
          if (start <= u.index && end >= u.index) {
            u.conditions = value(model);
          }
        });
        return ViewModel.update(path, updated, model);
      })(model, action)

    // 【画面モデル項目:path:string】の【値:index:(m:ViewModel) => number[]】列目表示状態を全て【値:value:(m:ViewModel) => any】に設定する
    case UIAction.UPDATE_RANGE_COLUMNS_VISIBLE_VALUE:
      return ((model, {path, index, value}):ViewModel => {
        const i: number[] = index(model);
        const updated = JSON.parse(JSON.stringify(ViewModel.get(path, model))) || [];
        updated.map((u) => {
          if (i.indexOf(u.index) !== -1) {
            u.conditions = value(model);
          }
        });
        return ViewModel.update(path, updated, model);
      })(model, action)

    // 【画面モデル項目:path:string】を初期状態に戻す
    case UIAction.RESET_VIEW_MODEL:
      return ((model, {path}):ViewModel => {
        return ViewModel.update(path, ViewModel.getInitialValue(path), model)
      })(model, action)

    // 【画面モデル項目:path:string】のスナップショットを取得する
    case UIAction.TAKE_SNAPSHOT_OF_VIEW_MODEL:
      return ((model, {path}):ViewModel => {
        ViewModel.takeSnapshot(path, model, action.auth())
        return model
      })(model, action)

    // 【画面モデル項目:path:string】のスナップショットをセッションストレージ上に取得する
    case UIAction.TAKE_SNAPSHOT_OF_VIEW_MODEL_ON_SESSION_STORAGE:
      return ((model, {path}):ViewModel => {
        ViewModel.takeSnapshot(path, model, action.auth(), true, true)
        return model
      })(model, action)

    // 【画面モデル項目:path:string】のスナップショットをメモリ上に取得する
    case UIAction.TAKE_SNAPSHOT_OF_VIEW_MODEL_ON_HEAP:
      return ((model, {path}):ViewModel => {
        ViewModel.takeSnapshot(path, model, action.auth(), false)
        return model
      })(model, action)

    // 【画面モデル項目:path:string】を直近のスナップショットの状態に戻す
    case UIAction.RESET_VIEW_MODEL_TO_LATEST_SNAPSHOT:
      return ((model, {path}):ViewModel => {
        return ViewModel.revertToLatestSnapshot(path, model, action.auth())
      })(model, action)

    // 【画面モデル項目:path:string】を直近のセッションストレージ上のスナップショットの状態に戻す
    case UIAction.RESET_VIEW_MODEL_TO_LATEST_SNAPSHOT_ON_SESSION_STORAGE:
      return ((model, {path}):ViewModel => {
        return ViewModel.revertToLatestSnapshot(path, model, action.auth(), true)
      })(model, action)

    // 【値:value:(m:ViewModel) => any】をトースト表示する【値:toastType:(m:ViewModel) => string】
    case UIAction.SHOW_TOAST:
      return ((model, {value, toastType}):ViewModel => {
        let toast;
        if (toastType(model) === 'basic') {
          toast = action.toast().create(value(model));
        } else if (toastType(model) === 'alert') {
          toast = action.toast().createAlert(value(model));
        } else if (toastType(model) === 'complete') {
          toast = action.toast().createComplete(value(model));
        } else {
          toast = action.toast().createWarning(value(model));
        }
        toast.onDidDismiss(() => {
          console.log('Dismissed toast');
        });
        toast.present();
        return model;
      })(model, action)

    // 【画面モデル項目:path:string】に選択したラベル値を設定する
    case UIAction.UPDATE_VIEW_MODEL_WITH_SELECTED_LABEL_VALUE:
      return ((model, {path}):ViewModel => {
        const selectedLabel = action.event.content
        return ViewModel.update(path, selectedLabel, model)
      })(model, action)

    // 【画面モデル項目:path:string】にリスト値【値:all:(m:ViewModel) => any】を選択Value【値:selectedValues:(m:ViewModel) => any】でフィルターし、ラベル値を設定する
    case UIAction.UPDATE_VIEW_MODEL_WITH_SELECTED_LABEL_VALUES:
      return ((model, {path, all, selectedValues}):ViewModel => {
        const allData: any[] = all(model);
        const selected: string[] = selectedValues(model);
        let selectedLabel: string[] = []
        allData.forEach(a => {
          if (selected.indexOf(a.value) !== -1) {
            selectedLabel.push(a.label);
          }
        });
        return ViewModel.update(path, selectedLabel, model);
      })(model, action)

    // 【値:target:(m:ViewModel) => string】を【値:splitValue:(m:ViewModel) => string】で分割し、前者を【画面モデル項目:one:string】、後者を【画面モデル項目:another:string】に設定する
    case UIAction.SPLIT_VALUE_AND_UPDATE_VIEW_MODEL:
      return ((model, {target, splitValue, one, another}):ViewModel => {
        const targetList: string[] = target(model).split(splitValue(model));
        const oneValue:string = targetList[0];
        const anotherValue: string = targetList[1];
        ViewModel.update(one, oneValue, model);
        return ViewModel.update(another, anotherValue, model);
      })(model, action)

    // 今年度年シーズン【値:tySsn:(m:ViewModel) => string】を基に、昨年度年シーズン【画面モデル項目:target:string】を設定する
    case UIAction.UPDATE_LY_BASED_ON_TY:
      return ((model, {tySsn, target}):ViewModel => {
        const ty: string = tySsn(model).split('-')[0];
        const ssn: string = tySsn(model).split('-')[1];
        const ly: string = (parseInt(ty) -1).toString();
        const lySsn: string = ly + '-' + ssn;
        return ViewModel.update(target, lySsn, model);
      })(model, action)

    // プルダウン【値:pulldownList:(m:ViewModel) => any】の【値:pulldownIndex:(m:ViewModel) => number】番目の要素を【画面モデル項目:pulldownSelected:string】に設定する
    case UIAction.UPDATE_VIEW_MODEL_WITH_PULLDOWN_VALUE:
      return ((model, {pulldownList, pulldownIndex, pulldownSelected}):ViewModel => {
        const targetList: any[] = pulldownList(model);
        let target: string = '';
        if (targetList && targetList.length > 0) {
          target = targetList[pulldownIndex(model) - 1] ? targetList[pulldownIndex(model) - 1].value + '' : '';
        }
        return ViewModel.update(pulldownSelected, target, model);
      })(model, action)

    // 【値:messageId:(m:ViewModel) => string】のメッセージをトースト表示する【値:toastType:(m:ViewModel) => string】
    case UIAction.SHOW_TOAST_MESSAGE:
      return ((model, {messageId, toastType}):ViewModel => {
        let toast;
        let messageText = action.systemMessage().textOf(messageId(model), {});
        if (toastType(model) === 'basic') {
          toast = action.toast().create(messageText);
        } else if (toastType(model) === 'alert') {
          toast = action.toast().createAlert(messageText);
        } else if (toastType(model) === 'complete') {
          toast = action.toast().createComplete(messageText);
        } else {
          toast = action.toast().createWarning(messageText);
        }
        toast.onDidDismiss(() => {
          console.log('Dismissed toast');
        });
        toast.present();
        return model;
      })(model, action)

    // 【値:messageId:(m:ViewModel) => string】のメッセージに【値:params:(m:ViewModel) => any】を埋め込んでトースト表示する【値:toastType:(m:ViewModel) => string】
    case UIAction.SHOW_TOAST_MESSAGE_WITH_PARAM:
      return ((model, {messageId, params, toastType}):ViewModel => {
        let toast;
        let messageText = action.systemMessage().textOf(messageId(model), params(model));
        if (toastType(model) === 'basic') {
          toast = action.toast().create(messageText);
        } else if (toastType(model) === 'alert') {
          toast = action.toast().createAlert(messageText);
        } else if (toastType(model) === 'complete') {
          toast = action.toast().createComplete(messageText);
        } else {
          toast = action.toast().createWarning(messageText);
        }
        toast.onDidDismiss(() => {
          console.log('Dismissed toast');
        });
        toast.present();
        return model;
      })(model, action)

    // 【画面モデル項目:path:string】の内容をメッセージエリアに表示する
    case UIAction.SHOW_ERROR_MESSAGE_WITH_VIEW_MODEL:
      return ((model, {path}):ViewModel => {
        let messages = ViewModel.get(path, model)
        if (!Array.isArray(messages)) {
          messages = [messages]
        }
        let errorMessages = []
        messages.forEach(v => {
          if (v.defaultMessage && v.messageId) errorMessages.push({modelPath: '_common_', message: v.defaultMessage, id: v.messageId})
        })
        if (errorMessages.length > 0) {
          model = ViewModel.update('errorMessages', errorMessages, model)
          const toast = action.toast().createAlert('Error occurred.')
          toast.present();
        }
        return model
      })(model, action)

    // 【画面モデル項目:path:string】に【値:value:(m:ViewModel) => any】の値を追加する
    case UIAction.PUSH_VALUES_TO_VIEW_MODEL:
      return ((model, {path, value}):ViewModel => {
        let targetList = ViewModel.get(path, model);
        if (Array.isArray(targetList)) {
          let newArray = [];
          let newValue = JSON.parse(JSON.stringify(value(model)));
          Array.prototype.push.apply(newArray, targetList);
          Array.prototype.push.apply(newArray, Array.isArray(newValue) ? newValue : [newValue]);
          return ViewModel.update(path, newArray, model);
        } else {
          return;
        }
      })(model, action)

    // 【画面モデル項目:recordsPath:string】のKey項目【値:key:(m:ViewModel) => string】が【値:value:(m:ViewModel) => any】の要素を【画面モデル項目:targetPath:string】に移動する
    case UIAction.MOVE_VALUES_TO_VIEW_MODEL:
      return ((model, {recordsPath, key, value, targetPath}):ViewModel => {
        const records = ViewModel.get(recordsPath, model);
        const filteredRecords = records.filter(record => record[key(model)] == value(model));
        if (filteredRecords.length > 0) {
          const targetArray = ViewModel.get(targetPath, model);
          const newArray = [];
          Array.prototype.push.apply(newArray, targetArray);
          Array.prototype.push.apply(newArray, filteredRecords);
          filteredRecords.forEach(record => records.splice(records.indexOf(record), 1))
          ViewModel.update(targetPath, newArray, model);
        }
        return model;
      })(model, action)

    // スプレッドセル更新内容【画面モデル項目:path:string】の【値:row:(m:ViewModel) => number】行目の【値:col:(m:ViewModel) => number】列目に【値:value:(m:ViewModel) => any】を設定する
    case UIAction.UPDATE_SPREADSHEET_CELL_VALUE:
      return ((model, {path, row, col, value}):ViewModel => {
        let cellContents = ViewModel.get(path, model)
        if (!cellContents || cellContents.length === 0) cellContents = []
        cellContents.push({row: row(model), col: col(model), value: value(model)})
        return ViewModel.update(path, cellContents, model)
      })(model, action)

    // スプレッドセル更新内容【画面モデル項目:path:string】の【値:col:(m:ViewModel) => number】列目の値を全く【値:value:(m:ViewModel) => any】に設定する
    case UIAction.UPDATE_SPREADSHEET_COLUMN_VALUE:
      return ((model, {path, col, value}):ViewModel => {
        let cellContents = ViewModel.get(path, model)
        if (!cellContents || cellContents.length === 0) cellContents = []
        cellContents.push({col: col(model), value: value(model)})
        return ViewModel.update(path, cellContents, model)
      })(model, action)

    // 【値:selected:(m:ViewModel) => string】の週頭日を【画面モデル項目:path:string】に設定する【値:fmt:(m:ViewModel) => string】
    case UIAction.UPDATE_BY_START_WEEK_DATE:
      return ((model, {selected, path, fmt}):ViewModel => {
        let selectedDate = selected(model);
        let day = moment(selectedDate).day(); // 0: Sun ~ 6: Sat
        let startWk = moment(selectedDate).subtract(day-1, 'd').format(fmt(model));
        return ViewModel.update(path, startWk, model);
      })(model, action)

    // 【値:authAIMUserInfo:(m:ViewModel) => any】を認可サービスに登録する
    case UIAction.SET_AUTH_AIM_USER_INFO:
      return ((model, {authAIMUserInfo}):ViewModel => {
        action.auth().setAuthAIMUserInfo(authAIMUserInfo(model));
        return model;
      })(model, action)


    default:
      return model
  }
}


// WEBPACK FOOTER //
// ./src/services/action.service.ts